// extracted by mini-css-extract-plugin
export default {"container":"ShopContainer_container__sgQYl","tipsterContainer":"ShopContainer_tipsterContainer__l5Mun"};